"use strict";
/**
 * Types copied from songwhip-release-tasks
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseTaskTypes = void 0;
var ReleaseTaskTypes;
(function (ReleaseTaskTypes) {
    ReleaseTaskTypes["SPOTIFY_PRESAVE"] = "spotify-presave";
    ReleaseTaskTypes["APPLE_MUSIC_PRESAVE"] = "apple-music-presave";
    ReleaseTaskTypes["DEEZER_PRESAVE"] = "deezer-presave";
    ReleaseTaskTypes["AMAZON_MUSIC_PRESAVE"] = "amazon-music-presave";
    ReleaseTaskTypes["EMAIL_NOTIFICATION"] = "email-notification";
})(ReleaseTaskTypes || (exports.ReleaseTaskTypes = ReleaseTaskTypes = {}));
//# sourceMappingURL=types.js.map